import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="legal-hero-overlay"></div>
        <div className="legal-hero-content">
          <h1>Privacy Policy</h1>
          <p>Last Updated: January 6, 2026</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            
            <h2>1. Introduction</h2>
            <p>
              Welcome to F&H Audio Solutions LLP ("we," "our," or "us"). We are committed to protecting your personal 
              information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and 
              safeguard your information when you visit our website or engage with our services.
            </p>
            <p>
              Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, 
              please do not access the site or use our services.
            </p>

            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Fill out contact forms or request consultations</li>
              <li>Subscribe to our newsletter or marketing communications</li>
              <li>Make purchases or inquiries about our products and services</li>
              <li>Contact us via phone, email, or other means</li>
              <li>Schedule appointments for site visits or consultations</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name and contact details (email address, phone number, mailing address)</li>
              <li>Company name and business information</li>
              <li>Project details and requirements</li>
              <li>Payment and billing information</li>
              <li>Communication preferences</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>When you visit our website, we automatically collect certain information about your device, including:</p>
            <ul>
              <li>IP address and browser type</li>
              <li>Operating system and device information</li>
              <li>Pages visited and time spent on our site</li>
              <li>Referring website addresses</li>
              <li>Clickstream data and browsing patterns</li>
            </ul>

            <h3>2.3 Cookies and Tracking Technologies</h3>
            <p>
              We use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, 
              and understand user preferences. You can control cookie preferences through your browser settings.
            </p>

            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect for various purposes, including:</p>
            <ul>
              <li>Providing and maintaining our services</li>
              <li>Processing your requests, orders, and consultations</li>
              <li>Communicating with you about products, services, and promotions</li>
              <li>Improving our website and customer experience</li>
              <li>Analyzing usage patterns and conducting market research</li>
              <li>Complying with legal obligations and protecting our rights</li>
              <li>Detecting and preventing fraud or security issues</li>
              <li>Sending administrative information and updates</li>
            </ul>

            <h2>4. Disclosure of Your Information</h2>
            <p>We may share your information in the following circumstances:</p>
            <ul>
              <li><strong>Service Providers:</strong> With third-party vendors who perform services on our behalf 
              (payment processors, installation partners, logistics providers)</li>
              <li><strong>Business Partners:</strong> With authorized dealers and brand partners for product 
              fulfillment and service delivery</li>
              <li><strong>Legal Requirements:</strong> When required by law, court order, or governmental request</li>
              <li><strong>Business Transfers:</strong> In connection with any merger, sale, or acquisition of our business</li>
              <li><strong>With Your Consent:</strong> When you have given us explicit permission to share your information</li>
            </ul>
            <p>
              We do not sell your personal information to third parties. All third-party service providers are 
              contractually obligated to maintain the confidentiality of your information.
            </p>

            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. These measures include:
            </p>
            <ul>
              <li>Encryption of sensitive data during transmission (SSL/TLS)</li>
              <li>Secure storage systems with access controls</li>
              <li>Regular security assessments and updates</li>
              <li>Employee training on data protection practices</li>
              <li>Restricted access to personal information on a need-to-know basis</li>
            </ul>
            <p>
              However, no method of transmission over the internet or electronic storage is 100% secure. While we 
              strive to protect your information, we cannot guarantee absolute security.
            </p>

            <h2>6. Data Retention</h2>
            <p>
              We retain your personal information only for as long as necessary to fulfill the purposes outlined in 
              this privacy policy, unless a longer retention period is required by law. Retention periods vary based on:
            </p>
            <ul>
              <li>The nature of the information collected</li>
              <li>Legal and regulatory requirements</li>
              <li>Our legitimate business needs</li>
              <li>Warranty and service obligations</li>
            </ul>

            <h2>7. Your Privacy Rights</h2>
            <p>Depending on your location, you may have the following rights regarding your personal information:</p>
            <ul>
              <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
              <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Objection:</strong> Object to processing of your information for certain purposes</li>
              <li><strong>Restriction:</strong> Request restriction of processing in certain circumstances</li>
              <li><strong>Data Portability:</strong> Request transfer of your data to another service provider</li>
              <li><strong>Withdraw Consent:</strong> Withdraw consent for processing where applicable</li>
            </ul>
            <p>
              To exercise these rights, please contact us using the information provided below. We will respond to 
              your request within 30 days.
            </p>

            <h2>8. Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal 
              information from children. If you become aware that a child has provided us with personal information, 
              please contact us immediately.
            </p>

            <h2>9. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices 
              or content of these external sites. We encourage you to review their privacy policies before providing 
              any information.
            </p>

            <h2>10. Updates to This Policy</h2>
            <p>
              We may update this privacy policy from time to time to reflect changes in our practices or legal requirements. 
              We will notify you of any material changes by posting the new policy on this page and updating the "Last Updated" 
              date. We encourage you to review this policy periodically.
            </p>

            <h2>11. International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries other than India. We ensure appropriate 
              safeguards are in place to protect your information in accordance with this privacy policy and applicable 
              data protection laws.
            </p>

            <h2>12. Contact Us</h2>
            <p>If you have questions or concerns about this privacy policy or our data practices, please contact us:</p>
            <div className="contact-details">
              <p><strong>F&H Audio Solutions LLP</strong></p>
              <p>16-2A, 1st Floor, Kannavarithota</p>
              <p>Guntur, Andhra Pradesh - 522001</p>
              <p>India</p>
              <p>Email: <a href="mailto:info@fhaudio.in">info@fhaudio.in</a></p>
              <p>Phone: <a href="tel:+919876543210">+91 98765 43210</a></p>
            </div>

            <h2>13. Compliance</h2>
            <p>
              We comply with applicable Indian data protection laws, including the Information Technology Act, 2000, 
              and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data 
              or Information) Rules, 2011.
            </p>

            <div className="legal-footer">
              <p>
                By using our website and services, you acknowledge that you have read and understood this Privacy Policy.
              </p>
              <Link to="/" className="btn btn-primary">Back to Home</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
